export default {"src":"/_next/static/media/qr_code.1f422704.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};